import { useMemo } from "react";
import { useWormhole } from "../../../../hooks/index.js";
function useEditorLayout(target) {
  const { worms } = useWormhole(target);
  return useMemo(
    () => worms.reduce(
      (acc, child) => {
        if (!isValidProps(child.props)) {
          return acc;
        }
        const { placement, position } = child.props;
        if (placement === "inside-scroll") {
          if (position === "above") {
            acc.insideScrollAbove.push(child);
          } else {
            acc.insideScrollBelow.push(child);
          }
        } else {
          if (position === "above") {
            acc.outsideScrollAbove.push(child);
          } else {
            acc.outsideScrollBelow.push(child);
          }
        }
        return acc;
      },
      {
        insideScrollAbove: [],
        insideScrollBelow: [],
        outsideScrollAbove: [],
        outsideScrollBelow: []
      }
    ),
    [worms]
  );
}
function isValidProps(props) {
  if (!props) {
    return false;
  }
  const obj = props;
  if (obj.placement !== "inside-scroll" && obj.placement !== "outside-scroll") {
    return false;
  }
  if (obj.position !== "above" && obj.position !== "below") {
    return false;
  }
  return true;
}
export {
  useEditorLayout
};
//# sourceMappingURL=useEditorLayout.js.map
